<script lang="ts">
import Hero from "@/Components/Generics/Hero.vue";
import PaginationNew from "@/Components/PaginationNew.vue";
import ScrollUtilities from "@/Helpers/ScrollUtilities";
import AppLayout from "@/Layouts/App.vue";
import CompaniesList from "@/Pages/CompaniesList.vue";
import FindCompany from "@/Pages/FindCompany.vue";
import { EconomicSectors, QualificationId, QualificationInput, QualificationsGroups, SelectedEconomicSectorIds } from "@/Types";
import { CompanyId } from "@/Types/company";
import { CompanySearchResults } from "@/Types/pagination";
import axios from "axios";
import { defineComponent, PropType } from "vue";

type MainVueData = {
    companies: CompanySearchResults;
    sectors: SelectedEconomicSectorIds;
    qualificationInput: QualificationInput;
    preselected: QualificationInput;

    searchingProcess: boolean;
    noCompanies: boolean;

    detailViewCompanyId: CompanyId | null;
};

export default defineComponent({
    name: "MainVue",
    components: {
        Hero,
        FindCompany,
        CompaniesList,
        PaginationNew,
    },
    layout: AppLayout,
    props: {
        qualificationGroups: {
            type: Array as PropType<QualificationsGroups>,
            required: true,
        },
        economicSectors: {
            type: Array as PropType<EconomicSectors>,
            required: true,
        },
    },
    data: (): MainVueData => {
        return {
            companies: { data: false },
            sectors: [],
            qualificationInput: [],
            preselected: [],

            searchingProcess: false,
            noCompanies: false,

            detailViewCompanyId: null,
        };
    },
    mounted() {
        const localQualificationInput = localStorage.getItem("qualificationInput");

        if (localQualificationInput) {
            this.preselected = JSON.parse(localQualificationInput);
            this.qualificationInput.slice(0);
            this.preselected.forEach((item) => {
                this.qualificationInput.push({ id: item.id, value: item.value });
            });
        }
    },
    methods: {
        scrollToJobfuchs(): void {
            const div: HTMLDivElement = document.querySelector("#startOfJobfuchs");
            window.scrollTo(0, div.offsetTop - 100);
        },
        reset() {
            this.preselected = [];
            this.qualificationInput.forEach((item) => {
                this.preselected.push({ id: item.id, value: 0 });
            });
        },
        handleSectorValueChanged(values): void {
            this.sectors = values;
            console.log(this.sectors);
        },
        handleQualificationValueChangedEvent(qualificationId: QualificationId, value: number) {
            let qualificationInputToRemove = this.qualificationInput.map((qualificationInput) => qualificationInput.id);
            let index = qualificationInputToRemove.indexOf(qualificationId);
            if (index >= 0) this.qualificationInput.splice(index, 1);
            this.qualificationInput.push({ id: qualificationId, value: value });
        },
        search(page = 1, pagination = false) {
            if (this.searchingProcess) return;

            if (pagination) ScrollUtilities.jumpToTop();
            // if (pagination) $("#searchButton").get(0).scrollIntoView();

            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let vueThis = this;
            const dataValues = this.qualificationInput.map((item) => {
                return { id: item.id, value: item.value };
            });
            this.searchingProcess = true;

            localStorage.setItem("qualificationInput", JSON.stringify(this.qualificationInput));
            var d = new Date();
            var startSearching = d.getTime();
            axios
                .post("/company/search", { qualificationInput: dataValues, sectors: this.sectors, page: page })
                .then(function (result) {
                    var d = new Date();
                    var endSearching = d.getTime();
                    var timeDiff = endSearching - startSearching;
                    var minWaitingTime = Math.max(0, 3000 - timeDiff);
                    if (pagination) minWaitingTime = 500;
                    setTimeout(function () {
                        vueThis.noCompanies = result.data.companies.total === 0;
                        vueThis.companies = result.data.companies;
                        vueThis.searchingProcess = false;
                        vueThis.$nextTick(function () {
                            // $("#companyList").get(0).scrollIntoView();
                            ScrollUtilities.jumpToTop();
                        });
                    }, minWaitingTime);

                    /*
                        vueThis.companies.splice(0);
                        const arrayForSorting = [];
                        for(const [key, company] of Object.entries(result.data.companies))
                        {
                            arrayForSorting.push({'index': key, 'rating': company.rating});
                        };
                        arrayForSorting.sort(function(a, b) {
                            if (a.rating > b.rating) return -1;
                            if (a.rating < b.rating) return 1;
                            return 0;
                        });
                        arrayForSorting.forEach((item) =>
                        {
                            vueThis.companies.push(result.data.companies[item.index]);
                        });
                        */
                })
                .catch((error) => {
                    console.error(error);
                    this.searchingProcess = false;
                });
        },

        resetSearch(): void {
            this.companies.data = false;
            this.$nextTick(() => {
                this.scrollToJobfuchs();
            });
        },
        changeDetailViewCompanyId(companyId: CompanyId | null): void {
            this.detailViewCompanyId = companyId;
        },
    },
});
</script>

<template>
    <div class="main-wrapper flex flex--v flex--valign-c flex--gap-60">
        <template v-if="companies.data === false">
            <Hero @click-find="scrollToJobfuchs()" />

            <FindCompany
                ref="startOfJobfuchs"
                :searching-process="searchingProcess"
                :economic-sectors="economicSectors"
                :selected-economic-sectors="sectors"
                :qualification-groups="qualificationGroups"
                :qualification-input="qualificationInput"
                @economic-sector-value-changed="handleSectorValueChanged"
                @qualification-value-changed="handleQualificationValueChangedEvent"
                @click-find-company="search()" />
        </template>

        <CompaniesList
            v-else
            :qualification-input="qualificationInput"
            :qualification-groups="qualificationGroups"
            :companies="companies.data"
            :no-companies="noCompanies"
            :detail-view-company-id="detailViewCompanyId"
            @click-back-to-search="resetSearch"
            @change-detail-view-company-id="changeDetailViewCompanyId" />

        <PaginationNew v-if="companies.data !== false && companies.last_page > 1 && !detailViewCompanyId" :pagination-data="companies" class="pagination-new" @paginate="search($event, true)" />
    </div>
</template>

<style lang="scss" scoped>
// NEW
.main-wrapper {
    .pagination-new {
        margin-top: rem(20);
    }
}

@include media-breakpoint-down(lg) {
    .main-wrapper {
        gap: rem(50);
    }
}
@include media-breakpoint-down(md) {
    .main-wrapper {
        gap: rem(40);
    }
}
@include media-breakpoint-down(sm) {
    .main-wrapper {
        gap: rem(30);
    }
}
</style>
